import { useState } from 'react';
import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoricalTable } from '../components/HistoricalTable';
import { HistoryPageLayout, type HistoryTab } from '../../components/HistoryPageLayout';

/**
 * Interior history page — tabbed scan/batch views. 1:1 functional
 * clone of the lightning history page (filters, columns, buttons,
 * pagination, export) — the only deltas are the data source (interior
 * sub-app) and the cost helper (FAL `direct_cost` only, no pricing
 * fallback).
 */
export function InteriorHistoryPage() {
  const [activeTab, setActiveTab] = useState<HistoryTab>('scan');

  return (
    <HistoryPageLayout activeTab={activeTab} onTabChange={setActiveTab}>
      {activeTab === 'scan' ? <HistoricalTable /> : <BatchHistoryTable />}
    </HistoryPageLayout>
  );
}
